import { useEffect } from "react";
import { Transition } from "@mantine/core";
import {
  Success1Icon,
  Success2Icon,
  CheckIcon,
} from "@form/components/common/icons";

import type { FC } from "react";

const SuccessModal: FC<{
  desc: string;
  opened: boolean;
  setOpened: (opened: boolean) => void;
  className?: string;
  showIcon?: boolean;
}> = ({ opened, setOpened, desc, className, showIcon }) => {
  useEffect(() => {
    if (opened) {
      const timer = setTimeout(() => {
        setOpened(false);
      }, 3000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [opened]);

  return (
    <Transition
      mounted={opened}
      transition="slide-up"
      duration={200}
      timingFunction="ease"
    >
      {(styles) => (
        <div
          className={`bg-white text-dark1 shadow-card p-7 z-20 relative ${className}`}
          style={{
            ...styles,
          }}
        >
          <div className="font-bold flex items-center">
            {showIcon && (
              <CheckIcon className="mr-2" fill="#47BA00"></CheckIcon>
            )}
            <span>{desc}</span>
          </div>
          {/* <Success1Icon className="absolute left-16 bottom-2"></Success1Icon>
          <Success2Icon className="absolute right-14 top-3"></Success2Icon> */}
          <img
            src="/form_images/success.gif"
            width={150}
            className="pointer-events-none bg-transparent absolute -z-10 scale-[2] left-[24%] -top-[-10%]"
          />
        </div>
      )}
    </Transition>
  );
};

export default SuccessModal;
